import { faArrowRightArrowLeft } from "@jewlr/pro-light-svg-icons/faArrowRightArrowLeft"
import {
  Box,
  Button,
  Flex,
  FontAwesomeIcon,
  MediaBox,
  Shimmer,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { push } from "redux-first-history"
import styled from "styled-components"

import { history } from "app-store-v2/index"
import { fetchShareEmail } from "app-store-v2/share/actions"
import AcceptPayments from "areas/cart/footer/accept-payments"
import ItemEditForm from "components/admin/item-edit-form"
import { openModal } from "components/modal"
import { IS_JEWLR, IS_PORTAL, isTestMode } from "helpers/application"

import AddToCartButton from "./add-to-cart-button"
import { ActionButton } from "./components"
import OutOfStockForm from "./out-of-stock-form"
import ShippingInfo from "./shipping-info"
import SocialShare from "./social-share"

const SendAHintBtn = styled(Button).attrs((props) => ({
  border: {
    _: "none",
    tablet: `1px solid ${props.theme.colors.neutral}`,
  },
  color: { _: "primary", tablet: "black" },
  fontSize: { _: "16px", tablet: "18px" },
  fontWeight: { _: 600, tablet: 300 },
  height: { _: "44px", tablet: "48px" },
  mx: "auto",
  textDecoration: { _: "underline", tablet: "none" },
  width: "100%",
  ...props,
}))``

const ReturnPolicyLink = () => (
  <Box textAlign={{ _: "center", tablet: "left" }}>
    <Button
      mb={2}
      onClick={() => {
        if (!isTestMode) {
          dataLayer.push({
            event: "clicked-pdp-return-policy",
          })
        }
        openModal("#return-policy")
      }}
      underline
      variant="text"
    >
      <FontAwesomeIcon fontSize="15px" icon={faArrowRightArrowLeft} mr={1} />
      <Typography fontSize="15px" fontWeight={{ _: "400", tablet: "500" }}>
        99-Day Return Policy
      </Typography>
    </Button>
  </Box>
)

const InternalWizardActions = ({
  adminMode,
  header,
  olid,
  openShareModal,
  orderNumber,
  outOfStockRef,
  prefStore,
  previewImage,
  wizardRef,
}) => {
  if (!header) return null

  if (!prefStore) {
    return (
      <>
        <Shimmer
          display={{ tablet: "none" }}
          height="48px"
          mb={1}
          width="100%"
        />
        <Shimmer height="48px" mb="20px" width="100%" />
        {IS_PORTAL() && <AcceptPayments />}
        {IS_JEWLR() && <ReturnPolicyLink />}
        <ShippingInfo />
        {IS_JEWLR() && <Shimmer height="48px" width="100%" />}
      </>
    )
  }

  if (header.product_out_of_stock) {
    return (
      <>
        <OutOfStockForm outOfStockRef={outOfStockRef} />
        <ShippingInfo />
      </>
    )
  } else if (header.params_olid_present) {
    return (
      <>
        <ItemEditForm />
        {adminMode ? (
          <ActionButton
            onClick={() => (window.location = `${header.form_url}?cancel=true`)}
            outline="neutral"
            rel="nofollow"
          >
            Cancel Change
          </ActionButton>
        ) : (
          <Link
            data-lc="wizard-actions"
            outline="neutral"
            rel="nofollow"
            to={`/order/change?order_number=${orderNumber}&lii=${olid}`}
          >
            <ActionButton>Cancel Change</ActionButton>
          </Link>
        )}
      </>
    )
  }

  return (
    <>
      {previewImage && (
        <MediaBox lessThan="tablet" mb={1}>
          <ActionButton
            fontWeight="600"
            onClick={() => openModal("#preview")}
            outline="blackPrint"
          >
            Preview Design
          </ActionButton>
        </MediaBox>
      )}
      <AddToCartButton wizardRef={wizardRef} />
      {IS_PORTAL() && <AcceptPayments />}
      {IS_JEWLR() && <ReturnPolicyLink />}
      <ShippingInfo />
      {IS_JEWLR() && (
        <Flex flexDirection={{ _: "row", desktop: "column" }}>
          <Box flex="1">
            <SendAHintBtn
              data-cy="product-wizard-send-a-hint-btn"
              onClick={() => openShareModal("product")}
            >
              Send a Hint
            </SendAHintBtn>
          </Box>
          <SocialShare />
        </Flex>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  const allViews = state.previewImage.data?.all_views || []
  const slides = state.previewImage.data?.images || []
  const previewSlide = Object.entries(slides).find(([view]) =>
    allViews.includes(view.replace("_view", ""))
  )

  return {
    adminMode: state.wizard.adminMode,
    header: state.wizard.header,
    olid: state.wizard.olid,
    orderNumber: state.wizard.orderNumber,
    prefStore: state.wizardUI.prefStore,
    previewImage: previewSlide ? previewSlide[1] : null,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openShareModal: () => {
      dispatch(fetchShareEmail())
      dispatch(
        push(
          `${history.location.pathname}${history.location.search}#share-modal`
        )
      )
    },
  }
}

InternalWizardActions.propTypes = {
  adminMode: PropTypes.bool,
  header: PropTypes.object,
  olid: PropTypes.any,
  openShareModal: PropTypes.func,
  orderNumber: PropTypes.string,
  outOfStockRef: PropTypes.object,
  prefStore: PropTypes.bool,
  previewImage: PropTypes.object,
  wizardRef: PropTypes.object,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalWizardActions)
